import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Category, SupplierMapping } from '@synergy/models';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';

export const CLEAR_SUPPLIER_CATEGORY_MAPPINGS = 'CLEAR_SUPPLIER_CATEGORY_MAPPINGS';
export const RECEIVE_SUPPLIER_CATEGORY_MAPPING = 'RECEIVE_SUPPLIER_CATEGORY_MAPPING';
export const RECEIVE_SUPPLIER_CATEGORY_MAPPINGS = 'RECEIVE_SUPPLIER_CATEGORY_MAPPINGS';

const receiveSupplierCategoryMappings = (supplierMappings: SupplierMapping<Category>[]) => {
    return {
        type: RECEIVE_SUPPLIER_CATEGORY_MAPPINGS,
        supplierMappings,
    };
};

const receiveSupplierCategoryMapping = (supplierMapping: SupplierMapping<Category>) => {
    return {
        type: RECEIVE_SUPPLIER_CATEGORY_MAPPING,
        supplierMapping,
    };
};

export const clearSupplierCategoryMappings = () => {
    return {
        type: CLEAR_SUPPLIER_CATEGORY_MAPPINGS,
    };
};

export const fetchSupplierCategoryMapping = (supplierId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.contactsAndOrganizations.Supplier.SupplierDetail.CategoryMapping.getCategoryMapping(
            supplierId
        );

        if (response.success) {
            dispatch(receiveSupplierCategoryMappings(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateSupplierCategoryMapping = (supplierId: number, supplierMapping: SupplierMapping<Category>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response =
            await api.contactsAndOrganizations.Supplier.SupplierDetail.CategoryMapping.updateCategoryMapping(
                supplierId,
                supplierMapping
            );

        if (response.success) {
            dispatch(receiveSupplierCategoryMapping(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
